import { fetchData } from '../api/dashboard';
import { SET_DASHBOARD_DATA } from '../constants/dashboard';
import { convertDashboardData } from '../utils/dashboard/dashboard';

const setData = (payload) => ({
  type: SET_DASHBOARD_DATA,
  payload
});

export const getDashboardData = () => (dispatch) => {
  dispatch(setData({ loading: true }));
  fetchData().then((res) => {
    let payload = convertDashboardData(res);
    payload.loading = false;
    return dispatch(setData(payload));
  });
};
